import React, { useState } from "react";
import "./main.css";
import { myProjects } from "./myProjects";
import { AnimatePresence, motion } from "framer-motion";
import VideoPlayer from "../videoPlayer/videoPlayer";
import { Link, useParams } from "react-router-dom";
const Main = () => {
  // show modals
  const [currentActive, setcurrentActive] = useState("all");
  const [arr, setArr] = useState(myProjects);
  // etat de title + video
  const [title, setTitle] = useState("");
  const [video, seVideo] = useState("");
  const handleClick = (buttonCategory) => {
    setcurrentActive(buttonCategory);

    const newArr = myProjects.filter((item) => {
      const ZZZ = item.category.find((myItem) => {
        return myItem === buttonCategory;
      });

      // (khasha treturni true bach tfilltra)
      return ZZZ === buttonCategory;
    });

    setArr(newArr);
  };

  return (
    <main id="project" className="flex">
      <section className="flex  left-section">
        <button
          onClick={() => {
            setcurrentActive("all");
            setArr(myProjects);
          }}
          className={currentActive === "all" ? "active" : null}
        >
          all projects
        </button>

        <button
          onClick={() => {
            handleClick("html");
          }}
          className={currentActive === "html" ? "active" : null}
        >
          HTML & CSS
        </button>

        <button
          onClick={() => {
            handleClick("js");
          }}
          className={currentActive === "js" ? "active" : null}
        >
          JavaScript
        </button>
        <button
          onClick={() => {
            handleClick("react");
          }}
          className={currentActive === "react" ? "active" : null}
        >
          React & Bootstrap
        </button>
        <button
          onClick={() => {
            handleClick("nextJs");
          }}
          className={currentActive === "nextJs" ? "active" : null}
        >
          nextJs
        </button>
        <button
          onClick={() => {
            handleClick("wordpress");
          }}
          className={currentActive === "wordpress" ? "active" : null}
        >
          wordpress
        </button>
        <button
          onClick={() => {
            handleClick("laravel");
          }}
          className={currentActive === "laravel" ? "active" : null}
        >
          laravel
        </button>
        <button
          onClick={() => {
            handleClick("api");
          }}
          className={currentActive === "api" ? "active" : null}
        >
          Api laravel
        </button>
        <button
          onClick={() => {
            handleClick("flutter");
          }}
          className={currentActive === "flutter" ? "active" : null}
        >
          flutter
        </button>
        <button
          onClick={() => {
            handleClick("ionic");
          }}
          className={currentActive === "ionic" ? "active" : null}
        >
          ionic
        </button>
        <button
          onClick={() => {
            handleClick("Figma");
          }}
          className={currentActive === "Figma" ? "active" : null}
        >
          Design
        </button>
      </section>
      <section className=" flex right-section">
        <AnimatePresence>
          {arr.map((item, index) => {
            return (
              <Link
                to={`/details`}
                // passer item au page details
                state={{ item }}
                className="link flex"
              >
                {/* // ajouter Microdata 'itemScope,itemType  */}
                <motion.article
                  itemScope
                  itemType="http://schema.org/Product"
                  layout
                  initial={{ transform: "scale(0.4)" }}
                  animate={{ transform: "scale(1)" }}
                  transition={{ type: "spring", damping: 8, stiffness: 50 }}
                  key={index}
                  className="cardP"
                >
                  <img
                    itemProp="image"
                    width={220}
                    height={190}
                    src={item.imgPath}
                    alt=""
                  />
                  <div style={{ width: "210px" }} className="box">
                    <div
                      itemProp="name"
                      style={{ marginBottom: "20px" }}
                      className="title"
                    >
                      {item.nameProject}
                    </div>
                    {/* <p className="sub-title">{item.desc}</p> */}
                    <div className="flex icons">
                      <div style={{ gap: "11px" }} className="flex">
                        <div className="icon-link">
                          <a itemProp="url" href={item.link}></a>
                        </div>
                        <div className="icon-github"></div>
                      </div>
                      <Link
                        to={`/details`}
                        // passer item au page details
                        state={{ item }}
                        // onClick={() => {
                        //   setModalShow(true);
                        //   seVideo(item.video);
                        //   setTitle(item.nameProject);
                        // }}
                        className="link flex"
                      >
                        more
                        <span
                          style={{ alignSelf: "end" }}
                          className="icon-arrow-right"
                        ></span>
                      </Link>
                      {/* <VideoPlayer
                        path={video}
                        title={title}
                        onshow={modalShow}
                        Hide={() => setModalShow(false)}
                      /> */}
                    </div>
                  </div>
                </motion.article>
              </Link>
            );
          })}
        </AnimatePresence>
      </section>
    </main>
  );
};

export default Main;
